/**
 * CL-SPECIFICATIONS-001B — Admin Specifications access (pure).
 */

import { isActiveCanonicalAssignment } from "./adminProjectProductsSelectionsModel";

export const ADMIN_SPECIFICATIONS_TAB_KEY = "specifications";
export const ADMIN_SPECIFICATIONS_TAB_LABEL = "Specifications";

function safeStr(value) {
  return String(value ?? "").trim();
}

export function resolveAdminProjectSpecificationsAccess({
  isGlobalAdmin = false,
  assignment = null,
  permissions = {},
} = {}) {
  const activeAssignment = isActiveCanonicalAssignment(assignment);
  const effectivePermissions =
    (assignment?.permissions && typeof assignment.permissions === "object" ? assignment.permissions : null)
    || (permissions && typeof permissions === "object" ? permissions : {});

  const canView = isGlobalAdmin
    || (activeAssignment && (
      effectivePermissions.canManageProjectSpecifications === true
      || effectivePermissions.canViewProjectSpecifications === true
    ));
  const canManage = isGlobalAdmin
    || (activeAssignment && effectivePermissions.canManageProjectSpecifications === true);

  return {
    canView,
    canManage,
    readOnly: canView && !canManage,
    assignmentActive: activeAssignment,
  };
}

export function shouldShowAdminSpecificationsTab(access = {}) {
  return access?.canView === true || access?.canManage === true;
}

export function resolveAuthorizedAdminSpecificationsTab({
  requestedTab = "",
  access = {},
  fallbackTab = "overview",
} = {}) {
  const tab = safeStr(requestedTab).toLowerCase();
  if (tab !== ADMIN_SPECIFICATIONS_TAB_KEY) return tab || fallbackTab;
  if (!shouldShowAdminSpecificationsTab(access)) return fallbackTab;
  return ADMIN_SPECIFICATIONS_TAB_KEY;
}
